module.exports = __webpack_public_path__ + "static/media/facebook.1b99d839.svg";